import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { ThemeProvider } from '@dasa-health/alma-react'
import { almaNavTheme } from '@dasa-health/components-react'
import { merge, Theme } from 'theme-ui'

import { Footer, FooterV2, Header } from '@nsw-paginas-deslogadas/components'
import { navTheme } from '../../theme'
import * as S from './styles'
import { BrandMapping } from '@nsw-paginas-deslogadas/assets'
import { useAppContext } from '@nsw-paginas-deslogadas/store'
import PromoBanner from '../PromoBanner'

const BASE_URL = process.env.REACT_APP_BASE_URL

const Layout: React.FC = ({ children }) => {
    const location = useLocation()
    type ThemeType = typeof navTheme
    const mergeNavWithAlmaTheme = merge(navTheme as Theme, almaNavTheme)
    const tagCanonical = document.querySelector('[rel="canonical"]') as HTMLInputElement
    const { brand } = useAppContext()
    const brandMap = BrandMapping[brand.mappingId]

    useEffect(() => {
        if (tagCanonical) tagCanonical.setAttribute('href', `${BASE_URL}/laboratorio${location.pathname}`)
        return () => {
            tagCanonical.setAttribute('href', `${BASE_URL}/`)
        }
    }, [location.pathname, tagCanonical])

    return (
        <>
            <S.Container data-testid="layout">
                <ThemeProvider theme={mergeNavWithAlmaTheme as ThemeType}>
                    <S.PageContent>
                        {brandMap.renderPromoBanner && <PromoBanner isAlta={brandMap.name === 'Alta'} />}
                        <Header />
                        {children}
                        {brandMap.renderLPV2 ? <FooterV2 /> : <Footer />}
                    </S.PageContent>
                </ThemeProvider>
            </S.Container>
        </>
    )
}

export default Layout
